import { render, staticRenderFns } from "./DetailReview.vue?vue&type=template&id=6cbd383c&scoped=true&"
import script from "./DetailReview.vue?vue&type=script&lang=js&"
export * from "./DetailReview.vue?vue&type=script&lang=js&"
import style0 from "./DetailReview.vue?vue&type=style&index=0&id=6cbd383c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd383c",
  null
  
)

export default component.exports